import { Alert, Avatar } from '@mui/material';
import { DropDownListComponent } from '@syncfusion/ej2-react-dropdowns/drop-down-list';
import { MultiSelectComponent } from '@syncfusion/ej2-react-dropdowns/multi-select';
import { RecurrenceEditorComponent } from '@syncfusion/ej2-react-schedule';
import { useEffect, useRef, useState } from 'react';
import { DateTimePickerComponent } from '@syncfusion/ej2-react-calendars/datetimepicker';
import { CoachAPI } from '../../../api/CoachAPI.js';
import { MEETING_MODE, MEETING_PLATFORM, SCHEDULE_TYPES } from './SchedulerConstant.js';
import { CheckBoxComponent } from '@syncfusion/ej2-react-buttons/index.js';
import { TextBoxComponent } from '@syncfusion/ej2-react-inputs';
import CustomPlaceAutocomplete from '../../CustomComponents/CustomPlaceAutocomplete.jsx';
import { SwitchComponent } from '@syncfusion/ej2-react-buttons';
import { isClubOwner, isClubStaff } from '../../../util/UserRoles.js';
import { validateTimesWithDetails } from '../../../util/CalendarUtil.js';



const FIELD_MAPPINGS = {
    scheduleType: { text: 'scheduleName', value: 'id' },
    event: { value: 'eventId', text: 'eventName' },
    playerTeam: { value: 'id', text: 'name' },
    coachOrg: { value: 'clubId', text: 'clubName' },
    team: { value: 'teamId', text: 'teamName' },
    court: { text: 'courtNumber', value: 'id' },
    meetingMode: { text: 'mode', value: 'id' },
    meetingPlatform: { text: 'platform', value: 'id' },
};

const EditorTemplate = ({ args, userInfo, clubId, events, coachOrgs, courtData, calenderConfig, players }) => {
    const [scheduleType, setScheduleType] = useState(args?.ScheduleType ?? "TEAM_PRACTICE");
    const [isAwayOrgRegisterd, setIsAwayOrgRegisterd] = useState(false);
    const [awayTeams, setAwayTeams] = useState([]);
    const [homeTeams, setHomeTeams] = useState([]);
    const [meetingMode, setMeetingMode] = useState('');
    const [teamPlayers, setTeamPlayer] = useState([]);
    const [isRSVP, setIsRSVP] = useState(false);
    const [error, setError] = useState('');
    const [isAttachAllMember, setIsAttachAllMember] = useState(false);
    const recObject = useRef(null);
    const dropdownRef1 = useRef(null);
    const dropdownRef2 = useRef(null);
    const dropdownRef3 = useRef(null);
    const dropdownRef4 = useRef(null);
    const awayTeamNameRef = useRef(null);
    const rsvpRef = useRef(null);
    const teamIdsRef = useRef(null);
    const modeRef = useRef(null);
    const platformRef = useRef(null);
    const maxSlotRef = useRef(null);
    const titleRef = useRef(null);
    const isAttachAllMemberRef = useRef(null);
    const isAttachAllGuestRef = useRef(null);


    const getAllUsersForAClub = async () => {
        try {
            const response = await CoachAPI.findAllTeamPlayerForCoach(clubId, userInfo.userId);
            setTeamPlayer(response.Data);

        } catch (error) {
            console.log(error);
        }
    };

    useEffect(() => {
        if (isRSVP && (calenderConfig?.coachPrivacy && !isClubOwner(userInfo) && !isClubStaff(userInfo))) {
            getAllUsersForAClub();
        }
        const saveButton = document?.querySelector('#Save');
        if (saveButton) {
            saveButton.addEventListener('click', checkValidation);
        }
        return () => {
            if (saveButton) {
                saveButton.removeEventListener('click', checkValidation);
            }
        }
    }, [isRSVP])


    const checkValidation = () => {
        const isRSVP = rsvpRef?.current?.checked;
        const maxSlot = maxSlotRef?.current?.value ?? 0;
        const teams = teamIdsRef?.current?.value;
        const venue = document.querySelector('#Venue')?.value ?? '';
        const desc = document.querySelector('#Description').value ?? '';
        const title = document.querySelector('#title').value ?? '';

        // Validate start and end times
        const error = validateTimesWithDetails(
            document.querySelector('#StartTime').value,
            document.querySelector('#EndTime').value
        );

        if (error) {
            setError(error);
            return;
        }

        if (isRSVP && maxSlot < 1) {
            setError('Max slot must be greater than one.');
            return;
        }
        if (venue.length > 300) {
            setError('Location cannot be greater than 300 character.');
            return;
        }

        if (desc.length > 5000) {
            setError('Description cannot be greater than 5000 character.');
            return;
        }

        if (title.length > 255) {
            setError('Title cannot be greater than 255 character.');
            return;
        }


        if ((!teams || teams?.length === 0) && !isAttachAllMember) {


            setError('Please select at least 1 player or team.');
            return;
        }
        setError('');

    };

    //validation prevent removing of logged in user
    const onRemoving = (args) => {
        if (args.item.getAttribute('data-value') === userInfo?.userId) {
            args.cancel = true;
        }
    }


    useEffect(() => {
        if (dropdownRef1.current && !args?.ScheduleType) {
            dropdownRef1.current.value = "TEAM_PRACTICE"
        }
        if (awayTeamNameRef.current && args.AwayTeamName) {
            awayTeamNameRef.current.value = args.AwayTeamName;
            const instance = awayTeamNameRef.current;

            if (instance) {
                instance.value = args.AwayTeamName; // set value
                // instance.updateFloatingLabel();        // float the label properly
            }
        }
        if (dropdownRef1.current && args?.ScheduleType) {
            dropdownRef1.current.value = args.ScheduleType;
            if (args.Id) {
                dropdownRef1.current.enabled = false;
            }
        }
        if (dropdownRef2.current && args?.EventId) {
            dropdownRef2.current.value = args.EventId;
        }

        if (modeRef.current && args?.MeetingData?.mode) {
            modeRef.current.value = args?.MeetingData?.mode;
            setMeetingMode(args?.MeetingData?.mode)
        }
        if (isAttachAllMemberRef.current && args?.IsAttachAllMember) {
            isAttachAllMemberRef.current.checked = args?.IsAttachAllMember;
            setIsAttachAllMember(args?.IsAttachAllMember);
        }

        setTimeout(() => {
            if (isAttachAllGuestRef.current && args?.IsAttachAllGuest) {
                isAttachAllGuestRef.current.checked = args?.IsAttachAllGuest;
            }
        }, 500);

        if (platformRef.current && args?.MeetingData?.platform) {
            platformRef.current.value = args?.MeetingData?.platform;
        }

        setTimeout(() => {
            if (maxSlotRef.current && args?.MaxSlot) {
                maxSlotRef.current.value = args?.MaxSlot;
            }
        }, 500);

        if (titleRef.current && args?.Subject) {
            titleRef.current.value = args?.Subject;
        }

        if (rsvpRef.current && args?.IsRSVP) {
            rsvpRef.current.checked = args?.IsRSVP;
            setIsRSVP(args?.IsRSVP);
        }
    }, []);

    useEffect(() => {
        if (teamIdsRef.current) {
            let value = teamIdsRef.current.value || [];
            if (!value.includes(userInfo.userId)) {
                teamIdsRef.current.value = [...value, userInfo.userId]
            }
            if (args?.TeamIds) {
                teamIdsRef.current.value = args.TeamIds;
            }
        }
    }, [teamIdsRef.current])
    console.log(calenderConfig);
    
    return (
        <table className='sm-custom-event-editor'>
            <tbody className='sm-custom-event-editor-tbody'>
                {error &&
                    <Alert severity='error'>
                        {error}
                    </Alert>}
                <tr className='sm_coach_scheduler_editor_templete_sec_1'>
                    <td>
                        <DropDownListComponent ref={dropdownRef1} floatLabelType="Auto"
                            onChange={(e) => setScheduleType(e.target.value)}
                            className='e-field'
                            id='schedule_type'
                            dataSource={SCHEDULE_TYPES}
                            fields={FIELD_MAPPINGS.scheduleType}
                            value={args.ScheduleType ?? ''}
                            placeholder='Schedule Type' />
                    </td>
                    <td>
                        {scheduleType === 'MEETING' ?
                            <DropDownListComponent ref={modeRef} floatLabelType="Auto"
                                isDeviceFullScreen={false}
                                allowFiltering={false}
                                showClearButton='false'
                                className='e-field'
                                id='MeetingMode'
                                fields={FIELD_MAPPINGS.meetingMode}
                                value={args?.MeetingData?.mode}
                                onChange={(e) => setMeetingMode(e.target.value)}
                                dataSource={MEETING_MODE}
                                placeholder='Meeting mode' />
                            :
                            <DropDownListComponent ref={dropdownRef2} floatLabelType="Auto"
                                isDeviceFullScreen={false}
                                allowFiltering={false}
                                className='e-field'
                                id='Event'
                                showClearButton='false'
                                fields={FIELD_MAPPINGS.event}
                                dataSource={events}
                                placeholder='Event' />}
                    </td>
                </tr>
                <tr>
                    <td className='sm_coach_scheduler_editor_templete_sec_5'>
                        <TextBoxComponent ref={titleRef} placeholder='Title' id='title' floatLabelType='Auto' />
                    </td>
                </tr>


                {(calenderConfig?.rsvprequired && !args?.RecurrenceID) &&
                    <tr className='sm_coach_scheduler_editor_templete_rsvp'>
                        <td>
                            <CheckBoxComponent ref={rsvpRef} id='is_rsvp' onChange={(e) => setIsRSVP(e.target.checked)} label='RSVP' />
                        </td>
                        {isRSVP &&
                            <td>
                                <TextBoxComponent id='maxSlot' ref={maxSlotRef} type='number' floatLabelType='Auto' placeholder='Max slot available' />
                            </td>}
                    </tr>}
                {(courtData?.length != 0 && scheduleType !== 'MEETING') &&
                    <tr className='sm_coach_scheduler_editor_court_number_input'>
                        <td>
                            <DropDownListComponent floatLabelType="Auto"
                                allowFiltering={false}
                                className='e-field'
                                id='CourtNumber'
                                fields={FIELD_MAPPINGS.court}
                                value={args.CourtNumber}
                                dataSource={courtData}
                                placeholder='Court' />
                        </td>
                    </tr>}
                {(scheduleType === 'EVENT' && !args?.Id) &&
                    <tr>
                        <td>
                            <CheckBoxComponent
                                id='isAwayOrgRegisterd'
                                checked={isAwayOrgRegisterd}
                                onChange={(event) => setIsAwayOrgRegisterd(event.target.checked)}
                                label="Is away organization registerd in sportmongle?" />
                        </td>
                    </tr>}
                {(scheduleType === 'EVENT' && !isAwayOrgRegisterd) && <tr className='sm_coach_scheduler_editor_templete_sec_4'>
                    <td>
                        <TextBoxComponent value={args.AwayOrganizationName} floatLabelType='Auto' placeholder="Away Organization" id='AwayOrganizationText' />
                    </td>
                </tr>}

                {(scheduleType === 'EVENT' && isAwayOrgRegisterd) &&
                    <tr className='sm_coach_scheduler_editor_templete_sec_4'>
                        <td>
                            <DropDownListComponent allowFiltering={true}
                                fields={FIELD_MAPPINGS.coachOrg}
                                id='AwayOrg'
                                // value={args.ScheduleType}
                                floatLabelType="Auto"
                                dataSource={coachOrgs}
                                value={args.AwayOrgId}
                                placeholder="Away Organization" />
                        </td>
                    </tr>}
                {(scheduleType === 'EVENT') &&
                    <tr className='sm_coach_scheduler_editor_templete_sec_2'>
                        <td><DropDownListComponent ref={dropdownRef3} allowFiltering={true} floatLabelType="Auto" value={args?.HomeTeamId} fields={FIELD_MAPPINGS.team} dataSource={homeTeams} className='e-field' id='home_team' placeholder='Home Team' /></td>
                        {isAwayOrgRegisterd ?
                            <td><DropDownListComponent allowFiltering={true} ref={dropdownRef4} floatLabelType="Auto" value={args?.AwayTeamId} fields={FIELD_MAPPINGS.team} dataSource={awayTeams} className='e-field' id='away_team' placeholder='Away Team' /></td>
                            :
                            <td>
                                <TextBoxComponent value={args?.AwayTeamName} floatLabelType='Auto' placeholder="Away Team Name"
                                    id='AwayTeamNameText'
                                />
                            </td>}

                    </tr>}
               {!calenderConfig?.coachPrivacy &&
                <tr style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                    <td style={{ width: 'max-content' }}>
                        <SwitchComponent
                            ref={isAttachAllMemberRef}
                            id='is_attach_all_member'
                            onChange={(e) => setIsAttachAllMember(e.target.checked)}

                        />
                    </td>
                    <td>
                        <label htmlFor='is_attach_all_member'>Select All member</label>
                    </td>
                </tr>}
                {isAttachAllMember &&
                    <tr>
                        <td>
                            <CheckBoxComponent ref={isAttachAllGuestRef} id='is_attach_guest' label='Include guest' />
                        </td>
                    </tr>}
                {((scheduleType === 'TEAM_PRACTICE' || scheduleType === 'MEETING' || scheduleType === 'MEET') && !isAttachAllMember) &&
                    <tr className='sm_coach_scheduler_editor_templete_sec_3'>
                        <td >
                            <MultiSelectComponent

                                className='e-field'
                                id='PlayerAndTeam'
                                ref={teamIdsRef}
                                dataSource={(isRSVP && calenderConfig?.coachPrivacy && !isClubOwner(userInfo) && !isClubStaff(userInfo)) ? teamPlayers : players}
                                fields={FIELD_MAPPINGS.playerTeam}
                                value={args?.TeamIds}
                                placeholder='Choose Player/Team'
                                data-name='Player'
                                removing={onRemoving}
                                itemTemplate={(data) => {
                                    return (
                                        <div style={{ display: 'flex', alignItems: 'center', padding: '10px', height: '30px' }}>
                                            <Avatar sx={{ height: 40, width: 40 }}
                                                src={
                                                    data?.logo
                                                        ? data?.team
                                                            ? `${import.meta.env.VITE_APP_BASE_URL}/team/logo/${data.logo}`
                                                            : `${import.meta.env.VITE_APP_BASE_URL}/user/user-profile-img/${data.logo}`
                                                        : undefined
                                                }
                                            />
                                            <div>
                                                <p style={{ margin: '0px', padding: '0px', fontWeight: 600, height: 15 }}>{data?.name}</p>
                                                <p style={{ margin: '0px', padding: '0px', }}>{data?.email}</p>
                                            </div>
                                        </div>
                                    );
                                }}
                                mode='Box'
                                allowFiltering={true}
                            >
                            </MultiSelectComponent>

                        </td>

                    </tr>}
                <tr className='sm_coach_scheduler_editor_templete_sec_7'>
                    <td>
                        <DateTimePickerComponent value={args?.StartTime} floatLabelType="Auto" data-testid="dateTimePickerFrom" placeholder='Start' className='e-field' id='StartTime' data-name='StartTime'>
                        </DateTimePickerComponent>
                    </td>
                    <td>
                        <DateTimePickerComponent value={args?.EndTime} floatLabelType="Auto" data-testid="dateTimePickerFrom" placeholder='End' className='e-field' id='EndTime' data-name='EndTime'>
                        </DateTimePickerComponent>
                    </td>
                </tr>

                {(scheduleType === 'TEAM_PRACTICE' || scheduleType === 'MEET' ||
                    (scheduleType === 'MEETING' && meetingMode === 'OFFLINE')) &&
                    <tr className='sm_coach_scheduler_editor_templete_sec_5'>
                        <td>
                            <CustomPlaceAutocomplete label='Location' value={(args?.Venue === undefined || args?.Venue === null) ? '' : args.Venue} id="Venue" />
                        </td>
                    </tr>}
                {(scheduleType === 'MEETING' && meetingMode === 'ONLINE') &&
                    <tr className='sm_coach_scheduler_editor_templete_sec_5'>
                        <td>
                            <DropDownListComponent ref={platformRef} floatLabelType="Auto"
                                allowFiltering={false}
                                className='e-field'
                                id='Platform'
                                fields={FIELD_MAPPINGS.meetingPlatform}
                                dataSource={MEETING_PLATFORM}
                                value={args?.MeetingData?.platform}
                                placeholder='Meeting Platform' />
                        </td>
                    </tr>}

                <tr>
                    <td>
                        <textarea id='Description' placeholder='Description' className='e-field e-input custom-border' defaultValue={args?.Description} name='Description' rows={5} cols={100}>
                        </textarea>
                    </td>
                </tr>
                <tr>
                    <td style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <p style={{ fontSize: '15px' }}>Do you want to send a notification for this event?</p>
                        <SwitchComponent id='isEmailDispatch' />
                    </td>
                </tr>
                { console.log('args <><><', args)}
                {(!args.hideRecurrenceEditor && !isRSVP) &&
                    <tr data-testid="recurrence-editor-container" className='content-wrapper recurrence-editor-wrap sm_coach_scheduler_editor_templete_sec_5'>
                        <td className='RecurrenceEditor1'>
                            <RecurrenceEditorComponent frequencies={['none', 'daily', 'weekly', 'monthly']} endTypes={['until', 'count']} value={args?.RecurrenceRule || null} id="coach-recurrence-editor" data-testid="recurrence-editor" ref={recObject} ></RecurrenceEditorComponent>

                        </td>
                    </tr>}
            </tbody>
        </table>
    )
}

export default EditorTemplate